import { render, staticRenderFns } from "./SolicitudesVehiculosIndex.vue?vue&type=template&id=beb48bc0"
import script from "./SolicitudesVehiculosIndex.vue?vue&type=script&lang=js"
export * from "./SolicitudesVehiculosIndex.vue?vue&type=script&lang=js"
import style0 from "./SolicitudesVehiculosIndex.vue?vue&type=style&index=0&id=beb48bc0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports